/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRecommendedDidCredentials.defs'
export { main as default } from './getRecommendedDidCredentials.defs'
